@if (component.text) {
<div class="w-12"
     [class]="component.align">
    <!-- text -->
    @if (component.type === 'text') {
    <href [link]="component.cta_link"
          [hrefTarget]="component.cta_target ? '_blank' : undefined">
        <div [class]="[component.text_style]"
             [style.color]="component.textColor"
             *iCms="'text' of component; content: 'html'; tag: component.tag; skipEmpty: true"></div>
    </href>
    }
    <!-- button -->
    @if (component.type === 'button') {
    <href [class.w-12]="component.fullWidth"
          [link]="component.cta_link"
          [hrefClass]="`${component.button_class}${component.fullWidth ? ' w-12' : ''}`"
          [hrefTarget]="component.cta_target ? '_blank' : undefined">
        <span [class]="component.button_class === 'button-inline' ? component.color : ''"
              *iCms="'text' of component"></span>
    </href>
    }
</div>
}